import { Component, OnInit } from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
  selector: 'app-asbmchome',
  templateUrl: './asbmchome.component.html',
  styleUrls: ['./asbmchome.component.scss']
})
export class AsbmchomeComponent implements OnInit {

  constructor(
      private meta: Meta,
      private titles: Title
  ) { }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Business Management Courses at ARNI School of Business');
        this.meta.updateTag({
            name: 'description',
            content: `Explore business management courses at ARNI School of Business Management & Commerce. Develop leadership skills and business expertise for a successful career.`
        });
    }

}
